// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

// TODO: Rename ProductOptionsPanel and ProductOptionsPricing views and models.
// Their names do not adequately reflect their functionality.

/*
  UMD header generated via modularize.js at 2015-04-08T01:12:32.814Z
  unresolved dependencies: THICK_PAPER_KINDS, PAPER_OPTION_LABELS, FLAT_FORMAT
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:cu3/info_dialog': ['InfoDialogView'],
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:constants': [],
  'minted:view/product_details/radio_envelope_picker': ['RadioEnvelopePicker'],
  'minted:url': []
})(this, function (m_module, Backbone, $, cu3_info_dialog_module,_ ) {

var M = m_module.M;
M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * Renders the product options panel for the product details page.
 */
M.View.ProductDetails.ProductOptionsPanel = Backbone.View.extend({
  template: M.Template.ProductDetails.ProductOptionsPanel,
  el: '#details',
  events: {
    'click .personalizeButton': 'onPersonalizeClick',
    'click .addToCartButton': 'onAddToCartClick',
    'change #showLogoCheckbox': 'onLogoCheckboxChange',
    'click a.logoLearnMore': 'onLogoLearnMoreClick',
    'click .paperDialogLink': 'onPaperLinkClick',
    'click .bindingDialogLink': 'onBindingLinkClick',
    'click .formatDialogLink': 'onFormatLinkClick',
    'click #product-formats .caption': 'onFormatLinkClick',
    'click .letterpressPricingDialogButton': 'onLetterpressPricingDialogLinkClick',
    'click .noProofMessageLink': 'onNoProofMessageLinkClick',
    'click .weddingProofMessageLink': 'onWeddingProofMessageLinkClick',
    'click .defaultProofMessageLink': 'onDefaultProofMessageLinkClick',
    'click .diLearnMore': 'openDiLearnMore',
  },

  /**
   * Initializes the ProductOptionsPanel container view.
   */
  initialize: function(options) {
    this.$el = $(this.el);
    this.isPreviewMode = options.isPreviewMode;

    var that = this;
    this.model.bind('priceUpdated', function() {
      that.render();
    });

    this.model.bind('invalidOptionAttempted', function(formatChoice, paperChoice, paperOptionChanged, paperSetsAreExclusive, availablePaperFormatPairs) {
      var opts = {
        forceSet: function(formatId, paperKindId, defaultFormatType, defaultPaperType) {
          that.model.forceFormatAndPaper(formatId, paperKindId, defaultFormatType, defaultPaperType);
        },
        setFormatFirst: function(formatId, paperKindId) {
          that.model.setFormat(formatId);
          that.model.setPaper(paperKindId);
        },
        setPaperFirst: function(formatId, paperKindId) {
          that.model.setPaper(paperKindId);
          that.model.setFormat(formatId);
        },
        availablePaperFormatPairs: availablePaperFormatPairs,
        paperOptionChanged: paperOptionChanged,
        paperSetsAreExclusive: paperSetsAreExclusive
      };
      that.parentWindow().openInvalidOptionDialog(formatChoice, paperChoice, opts);
    });

    // Google Product Feed - Use Minimum Quantity
    var urlParams = this._parseParentQuery();
    if (urlParams['source'] === 'pla'){
      var pricingDetails = that.model.getProductOptionsPricing();
      pricingDetails.set({'quantity': pricingDetails.getMinimumQuantity()});
    }

    if (urlParams['force_logo']) {
      this.model.set({
        forceLogo: true
      });
    } else {
      this.model.set({
        forceLogo: false
      });
    }

    this.bind('paperSelected', function(paperKindId) {
      if (this.model.get('collapseTripleThick')) {
        if (paperKindId == M.Model.ProductDetails.DOUBLE_THICK) {
          var $tripleThickOption = this.$('label[for="paperTripleThick"]').closest('tr');
          $tripleThickOption.show();
          that.parentWindow().openChangeToTripleThickDialog();
          this.model.set({
            collapseTripleThick: false
          });
        }
      }

      that.parentWindow().$('body').bind('changeToTripleThick', function() {
        that.model.setPaper(M.Model.ProductDetails.TRIPLE_THICK);
      });
    });


    this._requestProofCreationDays(this._estimatorPO());
    this._bindParentEvents();
    var diLearnMoreCopy = new M.Model.InfoDialog({
      body: '<p>FREE during our beta period! Any invitation sent to at least five recipients (not to yourself) during our beta period will remain free of charge even if beta period ends.</p>',
      title: 'Free during our beta period.'
    });
    this.diLearnMore = new M.View.InfoDialog({
      model: diLearnMoreCopy
    });
  },

  _estimatorPO: function() {
    return this.parentWindow().M.ProductDetails.estimatorPO;;
  },

  _bindParentEvents: function() {
    var that = this;

    this.parentWindow().$('body').bind('changeFormat', function(event, format) {
      that.model.setFormat(format);
    });

    this.parentWindow().$('body').bind('changeBinding', function(event, binding) {
      that.model.setBinding(binding);
    });

    this.parentWindow().$('body').bind('force_logo', function() {
      var $showLogoOption = that.$('.showLogoOption');
      $showLogoOption.find('input').attr('checked', 'checked');
    });

    this.parentWindow().$('body').bind('optout_logo', function() {
      var $showLogoOption = that.$('.showLogoOption');
      $showLogoOption.find('input').removeAttr('checked');
    });
  },

  _parseParentQuery: function() {
    return M.Url.ParseQuery(this.parentWindow().location.search.substr(1));
  },

  _requestProofCreationDays: function(estimatorPO) {
    var that = this;
    var proofDays = estimatorPO.getProofCreationDaysMessage();
    M.Model.DeliveryEstimator.Api.deliveryEstimate(estimatorPO, function(response) {
      estimatorPO.set(response[0]);
      that.model.set({
        proofCreationDays: proofDays
      });
    });
  },

  _getColorChoiceId: function() {
    return this.parentWindow().M.ProductDetails.getSelectedColorChoiceId();
  },

  _getDieCutCode: function() {
    return this.parentWindow().M.ProductDetails.getSelectedDieCutCode();
  },

  _getPricingMessage: function() {
    if (this.model.get('isLetterpress')) {
      return M.Template.ProductDetails.LetterpressPricingMessage({
        numColorsInProductPhoto: this.model.get('numColorsInProductPhoto')
      });
    } else if (this.model.get('productData')['is_stamp']) {
      return M.Template.ProductDetails.StampPricingMessage();
    }
    return '';
  },

  onLogoLearnMoreClick: function() {
    if (M.Model.ProductDetails.RECYCLED_PAPERS.includes(this.model.getPaperKindId())) {
      this.parentWindow().M.ProductDetails.openLogoDescriptionDialog(
        this.model.get('logoEcoDialogContent'));
    } else {
      this.parentWindow().M.ProductDetails.openLogoDescriptionDialog(
        this.model.get('logoDialogContent'));
    }

    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.VIRAL_LOGO_LEARN_MORE_CLICK,
      M.SKU.getProductKind(this.model.getProductSku()));
  },

  onPersonalizeClick: function(e) {
    if (this.isPreviewMode) {
      return;
    }
    var that = this;

    var personalizeUrl = this.getPersonalizeURL();
    var paperKindId = this.options.model.getPaperKindId();
    var formatId = this.options.model.getFormat();

    var $showLogoOption = this.$('.showLogoOption');
    if ($showLogoOption.length > 0 &&
        $showLogoOption.find('input').attr('checked')) {
      personalizeUrl += '&force_logo=1';
    }

    var isThickPaperSelected = _.contains(THICK_PAPER_KINDS, paperKindId);
    var isFoldedFormatSelected = _.contains(M.FOLDED_FORMATS, formatId);
    var isDieCutSelected = parent.M.ProductDetails.getSelectedDieCutCode();
    var isInvalidDiecutCombo = ((isThickPaperSelected && isDieCutSelected) ||
                                (isFoldedFormatSelected && isDieCutSelected));
    if (isInvalidDiecutCombo) {
      var paperName = PAPER_OPTION_LABELS[paperKindId];
      var opts = {
        acceptFunction: function() {
          that.parentWindow().location = personalizeUrl;
        },
        paperName: paperName,
        isThickPaperSelected: isThickPaperSelected,
        isFoldedFormatSelected: isFoldedFormatSelected
      };

      this.parentWindow().M.ProductDetails.displayDieCutIncompatWarningDialog(opts);
    } else {

      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.PDP,
        M.GA.TRACK_EVENT_ACTION.PERSONALIZE_CLICK,
        M.SKU.getProductKind(this.options.model.getProductSku()));

      this.parentWindow().location = personalizeUrl;
    }
  },

  onAddToCartClick: function(e) {
    if (this.isPreviewMode) {
      return;
    }

    // create form for non-customizable sku, incl Fabric, Selflaunch Stationery
    var method = "POST";
    var action = "/product/non-custom/add-to-cart";
    // TODO: rename this form to not be fabric-specific
    var $form = $('<form id="fabricForm" class="one two" style="display:none;">').
      attr('id', "fabricForm").
      attr('method', method).
      attr('action', action);

    var optionsAvailable = this.getOptionsAvailable();

    var queryParams = {
      quantity: this.model.getQuantity(),
      formatChoiceId: this.model.getFormat(),
      isSpiralBinding: !!this.model.getBinding(),
      paperChoice: this.model.getPaperKindId(),
      sku: this.model.getProductSku(),
      colorChoiceId: this._getColorChoiceId()
    };
    // Notebook refresh: notebooks no longer have grommet binding option
    if (this.model.get('isNotebook')) {
      queryParams.isSpiralBinding = true;
    }
    var availableEnvelopes = this.model.getAvailableEnvelopes();

    if (optionsAvailable && optionsAvailable[M.Model.ProductDetails.OPTION.ENVELOPE_COLOR]) {
      var envelopeColorId = availableEnvelopes[this.model.getEnvelopeColorId()].color_id;
      queryParams['envelopeColorId'] = envelopeColorId;
    }

    if (optionsAvailable && optionsAvailable[M.Model.ProductDetails.OPTION.DIE_CUT]) {
      queryParams['dieCutCode'] = this._getDieCutCode();
    }

    for (var key in queryParams) {
      if(queryParams[key] !== undefined) {
        var $hiddenField = $('<input>').
          attr("type", "hidden").
          attr("name", key).
          attr("value", queryParams[key]);
        $form.append($hiddenField);
      }
    }
    $('body').append($form);
    $form.submit();
  },

  onLogoCheckboxChange: function(event) {
    // NOTE(huan): I am not sure why there are two events tracking this
    // however I am keeping both of them.
    var $target = $(event.target);
    var isChecked = ($target.attr('checked') === 'checked');

    if (isChecked) {
      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.PDP,
        M.GA.TRACK_EVENT_ACTION.BACKER_LOGO_OPT_IN);
    }

    var eventAction = M.GA.TRACK_EVENT_ACTION.VIRAL_LOGO_CHECKBOX_UNCHECKED;

    // jquery version dependent method, the following is made to
    // be forwards compatiable.
    var checked = $target.prop ? $target.prop('checked') : $target.propAttr('checked');

    if (checked) {
      eventAction = M.GA.TRACK_EVENT_ACTION.VIRAL_LOGO_CHECKBOX_CHECKED;
    }

    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      eventAction,
      this.options.model.getProductSku()
    );
  },

  getRenderContext: function() {
    var context = {};

    if(this.model.get('isDigitalInvitationProduct')) {
      context.accessoryPrefix = 'Printed ';
    } else {
      context.accessoryPrefix = '';
    }
    context.isDownloadable = this.model.get('productData')['is_downloadable'];

    if (this.model.get('isOrnamentCard')) {
      context.topNote = 'You\'ll receive luxe pre-cut linen ribbons to tie each ornament.';
    } else if (this.model.get('productData')['is_downloadable']) {
      context.topNote = 'This product is a personalized digital file. You will not receive a printed version.';
    } else {
      context.topNote = false;
    }

    if (this.model.get('requiresExtraPostage') && !this.model.get('isOrnamentCard')) {
      if (this.model.get('isWeddingInvitation')) {
        context.warning = 'Note, extra postage is required when mailing \
square Invitations. Flat envelope rate may apply; please check \
with USPS.';
      } else {
        context.warning = 'Please note that extra postage is \
required when mailing square cards.';
      }
    } else if (this.model.get('isClassroomValentinesCard')) {
      context.warning = 'Please note our Classroom Valentines are meant \
to be handed out. They\'re too small to be sent through the US \
Postal Service.';
    } else if (this.model.get('isGreetingCard')) {
      context.warning = 'Please note we do not yet support recipient \
delivery for Greeting Cards. We will ship your card(s) to you for \
distribution.';
    } else {
      context.warning = false;
    }

    var isEnvelope = this.model.get('productData').envelope_colors.length > 1;
    if (this.model.get('isRCPNotAvailable') && !isEnvelope) {
      context.bottomNote = '\
Recipient address printing is not available for this product.';
    } else {
      context.bottomNote = false;
    }

    if (this.model.get('productData')['is_digital'] || this.model.get('isDigitalInvitationProduct')) {
      context.proofHtml = '';
    } else if (this.model.get('isWeddingMultiProof')) {
        context.proofHtml = '<span class="proofMessage floatL"> \
Complimentary <a class="weddingProofMessageLink">digital proofs</a> included. \
</span>';
    } else if (this.model.get('isNotProof')) {
        context.proofHtml = '<span class="proofMessage floatL"> \
Please note that you will not receive a \
digital proof of your order. <a class="noProofMessageLink">Why?</a> \
</span>';
    } else {
      context.proofHtml = '<span class="proofMessage floatL">1 free ' +
        '<a class="instrumentedElement defaultProofMessageLink" ' +
          'data-instrumented-eventspec="click" ' +
          'data-action="M.GA.TRACK_EVENT_ACTION.DIGITAL_PROOF_CLICK" ' +
          'data-instrumented-extrainfo-sku="' +
          this.model.get('productData').product_sku + '"' +
        '>proof</a> per item ordered.</span>';
    }
    context.showQuantity = this.model.hasQuantity();
    context.shouldShowEachPrice = this.shouldShowEachPrice();
    context.unitName = this.model.get('unitName');



    context.weddingViralityLabel = 'Yes, I want to share my support for independent designers. \
<a class="logoLearnMore">Learn more</a>.';

    var totalPrice = this.options.model.getTotalPrice();
    var quantity = this.options.model.getQuantity();
    var pricePerPiece = totalPrice / quantity;

    _(context).extend({
      totalPrice: totalPrice.toFixed(2),
      quantity: quantity,
      pricePerPiece: pricePerPiece.toFixed(2)
    });
    context.thickPaperSelected = this.isThickPaperSelected();

    // we only want to show the 'about our paper' dialog if there is more than
    // one paper option.
    var isTBLTBF = this.model.get('productData') && this.model.get('productData').product_sku && M.SKU.isTableNumber(this.model.get('productData').product_sku);
    context.isTBLTBFProduct = isTBLTBF;
    context.shouldShowPaperDialog =
        this.model.getProductOptionsPricing().get('paperOptionList').length > 1;

    context.shouldShowHeading = this.shouldShowHeading();
    context.pricingMessage = this._getPricingMessage();

    return _(this.model.toJSON()).extend(context);
  },

  getOptionsAvailable: function() {
    var optionsAvailable = {};
    optionsAvailable[M.Model.ProductDetails.OPTION.PAPER] =
      (this.model.get('isMagnet') ||
      this.model.get('productData').paper_options.length > 0) &&
      !this.model.get('isFabric') &&
      !this.model.get('productData')['is_digital'] &&
      !this.model.get('hidePaperTypes');
    optionsAvailable[M.Model.ProductDetails.OPTION.FABRIC] =
      (this.model.get('isFabric') &&
      this.model.get('productData').paper_options.length > 1);
    optionsAvailable[M.Model.ProductDetails.OPTION.ENVELOPE_COLOR] =
      this.model.get('productData').envelope_colors.length > 1;
    optionsAvailable[M.Model.ProductDetails.OPTION.FORMAT] =
      this.model.get('productData').formats.length > 1 &&
      !this.model.get('productData')['is_stamp'];
    optionsAvailable[M.Model.ProductDetails.OPTION.STAMP_DENOMINATION] =
      this.model.get('productData')['is_stamp'];
    optionsAvailable[M.Model.ProductDetails.OPTION.BINDING] =
      this.model.get('productData').bindings.length > 1;
    optionsAvailable[M.Model.ProductDetails.OPTION.DIE_CUT] = this.model.get('hasDieCutOption');
    return optionsAvailable;
  },

  /**
   * Renders the HTML for the product options panel, utilizing the views
   * for the various pickers.
   */
  render: function() {
    var that = this;

    var optionsAvailable = this.getOptionsAvailable();

    var context = _(this.getRenderContext()).extend({
      optionsAvailable: optionsAvailable,
      isPreviewMode: that.isPreviewMode
    });

    this.$el.html(this.template(context));

    this.renderQuantityPicker();

    if (optionsAvailable[M.Model.ProductDetails.OPTION.FORMAT] ||
        optionsAvailable[M.Model.ProductDetails.OPTION.STAMP_DENOMINATION]) {
      this.renderFormatPicker();
    }

    if (optionsAvailable[M.Model.ProductDetails.OPTION.ENVELOPE_COLOR]) {
      this.renderEnvelopePicker();
    }

    if (optionsAvailable[M.Model.ProductDetails.OPTION.PAPER] ||
      optionsAvailable[M.Model.ProductDetails.OPTION.FABRIC]) {
      this.renderPaperPicker();
    }

    if (optionsAvailable[M.Model.ProductDetails.OPTION.BINDING]) {
      this.renderBindingPicker();
    }

    if (optionsAvailable[M.Model.ProductDetails.OPTION.DIE_CUT]) {
      this.renderDieCutPanel();
    }

    this.renderAccessories();
    this.trigger('optionsPanelResized');

    // Rebind tracking events to pick up options panel elements that were
    // just added to the DOM.
    M.createInstrumentedElements(M.GA.TRACK_EVENT_CATEGORY.PDP);

    return this;
  },

  renderQuantityPicker: function() {
    var that = this;
    var quantityPicker = new M.View.ProductDetails.QuantityPicker({
      model: this.model.getProductOptionsPricing(),
      unitName: this.model.get('unitName')
    }).render();

    this.$el.find('.quantityPicker').replaceWith(
      quantityPicker.$el
    );

    quantityPicker.bind('quantitySelected', function(quantity) {
      that.model.getProductOptionsPricing().set({'quantity': quantity});
      that.render();

      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.PDP,
        M.GA.TRACK_EVENT_ACTION.CHANGE_QUANTITY,
        M.SKU.getProductKind(that.model.getProductSku()),
        quantity);
    });
  },

  renderBindingPicker: function() {
    var that = this;

    var picker = new M.View.ProductDetails.RadioBindingPicker({
      model: this.model.getProductOptionsPricing()
    });

    this.$el.find('.bindingPicker').replaceWith(
      picker.render().el
    );

    picker.bind('bindingSelected', function(bindingId) {
      that.model.setBinding(bindingId);
      that.trigger('journalOptionSelected', that.model.getFormat());

      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.PDP,
        M.GA.TRACK_EVENT_ACTION.CHANGE_BINDING,
        M.SKU.getProductKind(that.model.getProductSku()),
        bindingId);
    });

    picker.bind('moreButtonClicked', function() {
      that.trigger('optionsPanelResized');
    });

    that.trigger('journalOptionSelected', that.model.getFormat());
  },

  renderFormatPicker: function() {
    var that = this;

    var isPartyProductIndividualCustomization =
      this.model.get('productData').party_individual_customizable;

    var formatPicker = new M.View.ProductDetails.RadioFormatPicker({
      model: this.model.getProductOptionsPricing(),
      isPartyProductIndividualCustomization: isPartyProductIndividualCustomization,
      shouldShowPriceDiff: this.shouldShowPriceDiff(),
      stampDenominations: this.model.get('stamp_denominations')
    }).render();

    this.$el.find('.formatPicker').replaceWith(
      formatPicker.$el
    );

    formatPicker.bind('formatSelected', function(formatId) {
      // Uncollapse triple thick because we don't want two dialogs
      // to appear when folded + double thick is choosen.
      that.model.set({
        collapseTripleThick: false
      });

      that.model.setFormat(formatId);
      that.trigger('journalOptionSelected', formatId);

      var gaData = {
        target: M.GA.TRACK_EVENT_CATEGORY.PDP,
        action: M.GA.TRACK_EVENT_ACTION.CHANGE_FORMAT,
        label:  M.SKU.getProductKind(that.model.getProductSku()),
        value: formatId
      };
      var trackApiData = {
        feature: M.GA.TRACK_EVENT_CATEGORY.PDP,
        event: M.GA.TRACK_EVENT_ACTION.CHANGE_FORMAT,
        sku: that.model.getProductSku(),
        format_name: M.Model.ProductDetails.FORMAT_OPTION_LABELS[formatId]
      };
      M.sendTrackAPIAndGAEvent(gaData, trackApiData);
    });

    formatPicker.bind('moreButtonClicked', function() {
      that.trigger('optionsPanelResized');
    });
  },

  renderEnvelopePicker: function() {
    var that = this;
    var envelopeColorPicker = new M.View.ProductDetails.RadioEnvelopePicker({
      model: this.model.getProductOptionsPricing(),
    }).render();

    this.$el.find('.envelopePicker').replaceWith(
      envelopeColorPicker.$el
    );

    envelopeColorPicker.bind('envelopeSelected', function(colorOptionId) {
      that.model.setEnvelope(colorOptionId);
      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.PDP,
        M.GA.TRACK_EVENT_ACTION.CHANGE_ENVELOPE,
        M.SKU.getProductKind(that.model.getProductSku()),
        colorOptionId);
    });

    envelopeColorPicker.bind('moreButtonClicked', function() {
      that.trigger('optionsPanelResized');
    });
  },

  renderPaperPicker: function() {
    var that = this;

    var paperPicker = new M.View.ProductDetails.RadioPaperPicker({
      model: this.model.getProductOptionsPricing(),
      collapseTripleThick: this.model.get('collapseTripleThick')
    }).render();

    paperPicker.bind('postageDialogRequested', function(paperKindId) {
      that.trigger('postageDialogRequested', paperKindId);
    });

    paperPicker.bind('moreButtonClicked', function() {
      that.trigger('optionsPanelResized');
    });

    paperPicker.bind('paperSelected', function(paperKindId) {
      that.model.setPaper(paperKindId);
      that.trigger('paperSelected', paperKindId);
      var gaData = {
        target: M.GA.TRACK_EVENT_CATEGORY.PDP,
        action: M.GA.TRACK_EVENT_ACTION.CHANGE_PAPER,
        label:  M.SKU.getProductKind(that.model.getProductSku()),
        value: paperKindId
      };
      var trackApiData = {
        feature: M.GA.TRACK_EVENT_CATEGORY.PDP,
        event: M.GA.TRACK_EVENT_ACTION.CHANGE_PAPER,
        sku: that.model.getProductSku(),
        paper_name: M.Model.ProductDetails.PAPER_OPTION_LABELS[paperKindId]
      };
      M.sendTrackAPIAndGAEvent(gaData, trackApiData);
    });

    this.$el.find('.paperPicker').replaceWith(
      paperPicker.$el
    );
  },

  renderAccessories: function() {
    var that = this;

    _(this.options.model.get('accessoriesPricingDict')).each(function(accessoryOptionsPricing, accessorySku){
      var accessoryQuantityPicker = new M.View.ProductDetails.QuantityPicker({
        model: accessoryOptionsPricing
      });
      accessoryQuantityPicker.bind('quantitySelected', function(quantity) {
        accessoryOptionsPricing.set({'quantity': quantity});
        that.render();
      });

      // Used to notify the zoom dialog through the parent window
      that.trigger(
        'accessory_quantity_changed_details_panel',
        accessoryOptionsPricing);

      that.$el.find('.quantityPicker-' + accessorySku).html(
        accessoryQuantityPicker.render().el
      );
    });
  },

  renderDieCutPanel: function() {
    var dieCutPanel = new M.View.ProductDetails.DieCutPanel({
      model: this.model.getProductOptionsPricing()
    }).render();

    this.$el.find('.shapePicker').replaceWith(
      dieCutPanel.$el
    );
  },

  isThickPaperSelected: function() {
    var selectedPaperId = this.options.model.getPaperKindId();
    return _.contains(THICK_PAPER_KINDS, selectedPaperId);
  },

  isFlatFormatSelected: function() {
    var formatId = this.options.model.getFormat();
    return formatId == FLAT_FORMAT;
  },

  /**
   * Returns the URL for CU3 customization based on the current properties of
   * the ProductOptionsPricing model.
   *
   * If there are accessories selected, constructs a URL for suite creation.
   *
   * TODO: Add unit tests for the following test cases:
   * 1. Given a product options panel with no accessories, verify that a URL of
   * format /personalize/SKU is given.
   * 2. Given a ProductOptionsPanel model with accessories available but all
   * with a selected quantity of 0, verify that a URL of the format
   * /personalize/SKU is given.
   * 3. Given a ProductOptionsPanel model with accessories where at least one
   * has a quantity > 0, verify that a URL of the format
   * /personalize/setup_suite?sku=&quantity=&tier_paper_kind_id=&tier_format_id=
   * &accessories={accessorySku: quantity} is given.
   */
  getPersonalizeURL: function() {
    if (this.options.model.accessoriesSelected()) {
      var baseURL = '/personalize/setup_suite';

      var queryParams = {
        sku: this.options.model.getProductSku(),
        quantity: this.options.model.getQuantity(),
        tier_paper_kind_id: this.options.model.getPaperKindId(),
        tier_format_id: this.options.model.getFormat(),
        accesories: JSON.stringify(this.options.model.getAccessoryQuantities()),
        die_cut_code: this.parentWindow().M.ProductDetails.getSelectedDieCutCode(),
        color_choice_id: this.parentWindow().M.ProductDetails.
          getSelectedColorChoiceId(),
      }

      return baseURL + '?' + $.param(queryParams);
      // TODO: propagate color choice + diecut choice for this use case
    } else {
      var baseURL = '/personalize/' + this.options.model.getProductSku();
      var queryParams = {
        q: this.options.model.getQuantity(),
        po: this.options.model.getPaperKindId(),
        sf: this.options.model.getFormat(),
        ecId: this.options.model.getEnvelopeColorId()
      };

      if (this.options.model.getBinding()) {
        queryParams['bId'] = this.options.model.getBinding();
      }

      var colorChoiceId = this.parentWindow().M.ProductDetails.
        getSelectedColorChoiceId();

      if (colorChoiceId) {
        queryParams['ccId'] = colorChoiceId;
      }

      var dieCutChoiceCode = this.parentWindow().M.ProductDetails.
        getSelectedDieCutCode();

      if (dieCutChoiceCode &&
          !this.isThickPaperSelected() &&
          (this.isFlatFormatSelected() || this.model.get('isDigitalInvitationProduct'))) {
        queryParams['dcC'] = dieCutChoiceCode;
      }

      var altGreetingIdx = this.parentWindow().M.ProductDetails.
        getSelectedAltGreetingIndex();

      if (altGreetingIdx !== undefined) {
        queryParams['agI'] = altGreetingIdx
      }

      return baseURL + '?' + $.param(queryParams);
    }
  },

  shouldShowPriceDiff: function() {
    return !this.model.get('productData')['is_stamp'];
  },

  shouldShowEachPrice: function() {
    return !this.model.get('productData')['is_stamp'];
  },

  shouldShowHeading: function() {
    return this.model.getProductOptionsPricing().get('paperOptionList').length > 1 ||
      this.model.get('productData')['is_stamp'];
  },

  parentWindow: function() {
    return window.parent;
  },

  onPaperLinkClick: function() {
    this.parentWindow().openPaperDialog();
    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.ABOUT_PAPERS_CLICK,
      M.SKU.getProductKind(this.model.getProductSku()));
  },

  onBindingLinkClick: function() {
    this.parentWindow().openBindingDialog();
    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.ABOUT_BINDINGS_CLICK,
      M.SKU.getProductKind(this.model.getProductSku()));
  },

  onFormatLinkClick: function() {
    this.parentWindow().openFormatDialog();
    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.ABOUT_FORMATS_CLICK,
      M.SKU.getProductKind(this.model.getProductSku()))
  },

  onLetterpressPricingDialogLinkClick: function() {
    this.parentWindow().openLetterpressPricingDialog();
    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.LETTERPRESS_ABOUT_PRICING_CLICK,
      M.SKU.getProductKind(this.model.getProductSku()));
  },

  onNoProofMessageLinkClick: function() {
    this.parentWindow().M.ProductDetails.openNoProofDialog();
    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.PROOF_MESSAGE_NO_PROOF_CLICK,
      M.SKU.getProductKind(this.model.getProductSku()));
  },

  onWeddingProofMessageLinkClick: function() {
    this.parentWindow().M.ProductDetails.openWeddingProofDialog(this.model.get('proofCreationDays'));
    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.PROOF_MESSAGE_WEDDING_PROOF_CLICK,
      M.SKU.getProductKind(this.model.getProductSku()));
  },

  onDefaultProofMessageLinkClick: function() {
    this.parentWindow().M.ProductDetails.openDefaultProofDialog(this.model.get('proofCreationDays'));
    M.GA.trackEvent(
      M.GA.TRACK_EVENT_CATEGORY.PDP,
      M.GA.TRACK_EVENT_ACTION.PROOF_MESSAGE_DEFAULT_PROOF_CLICK,
      M.SKU.getProductKind(this.model.getProductSku()));
  },
  openDiLearnMore: function(){
    this.diLearnMore.render();
  }

});

return {
};

});
